import * as React from 'react';
import { Link } from 'react-router';
import { __, __r } from 'react-i18n';
import { FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { IconImg } from '../../Defaults/Icon/IconImg';
import * as uploadSrc from '../../../../assets/zemplin/upload_blue.svg';
import * as emptyCartImg from '../../../../assets/zemplin/shoppingbag-empty.svg';
import { TextP } from '../../Defaults/Text';
import { ButtonPrimaryLink } from '../General/Button';

interface Props {
  theme: any;
}

function SanitasEmptyCart({ theme }: Props) {
  return (
    <Wrapper>
      <SvgIcon
        icon={IconType.cartLarge}
        viewBox="0 0 48 48"
        width={48}
        height={48}
        alt={__('Ikonka prázdneho košíka')}
      />
      <Title>{__('Váš nákupný košík je prázdny')}</Title>
      <SmallText>
        {__('Pokračujte v nakupovaní a pridajte produkty do košíka.')}
      </SmallText>
      <ButtonPrimaryLink to={'/'}>
        {__('Pokračovať v nakupovaní')}
      </ButtonPrimaryLink>
    </Wrapper>
  );
}

const Wrapper = styled(FlexColCenter)`
  width: 100%;
  margin: 0 auto;
  padding: ${rem(24)} 0;

  ${({ theme }) => theme.mediab.m580`
   padding: ${rem(32)} 0 0;
  `}
`;

const Title = styled.h2`
  margin: ${rem(32)} 0;
  font-size: ${rem(30)};
  font-family: ${({ theme }) => theme.font.secondary};
  color: black;
  line-height: ${rem(38)};
  font-weight: 500;

  ${({ theme }) => theme.mediab.m580`
    font-size: ${rem(24)};
    line-height: ${rem(32)};
    text-align: center;
  `}
`;

const SmallText = styled(TextP)`
  font-weight: 300;
  font-family: ${({ theme }) => theme.font.primary};
  line-height: ${rem(18)};
  font-size: ${rem(14)};
  margin-bottom: ${rem(32)};
  text-align: center;
  color: black;
`;

const WithTheme: any = withTheme(SanitasEmptyCart);
export { WithTheme as SanitasEmptyCart };
